import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MapService } from '../../services';

@Component({
  selector: 'task-static-map',
  templateUrl: './task-static-map.component.html',
})
export class TaskStaticMapComponent implements OnChanges {
  @Input() jobId: number = null;

  @Input() taskIds: number[] = [];

  @Input() width: number = 230;

  @Input() height: number = 230;

  @Input() scale: 1 | 2 = 1;

  @Input() includeTracking: boolean = false;

  @Input() includePauses: boolean = false;

  staticMapSrc: string;

  constructor(private mapService: MapService) {}

  public async ngOnChanges(changes: SimpleChanges) {
    if (this.jobId || this.taskIds?.length > 0) {
      this.staticMapSrc = await this.mapService.getStaticMapUrlFromTasks({
        taskIds: this.taskIds,
        jobId: this.jobId,
        includePauses: this.includePauses,
        includeTracking: this.includeTracking,
        options: {
          mapSize: `${this.width}x${this.height}`,
          scale: this.scale,
        },
      });
    }
  }
}
